export const SET_GOALS = 'SET_GOALS'
export const ADD_GOAL = 'ADD_GOAL'
export const UPDATE_GOAL = 'UPDATE_GOAL'
export const DELETE_GOAL = 'DELETE_GOAL'
